<template>
<div>
  <b-container class="bg-white py-4">
    <b-row class="mb-4" v-if="!permissions.createMigration">
      <b-col>
        No access
      </b-col>
    </b-row>
    <b-row class="mb-4" v-if="permissions.createMigration">
      <b-col>
          <h2>Knex migrations</h2>
          <h4 class="my-4">Current version</h4>
          <p>Check current verstion of the migration</p>
          <div><b-button variant="primary" v-on:click="currentversion">Check current version</b-button></div>
          <h4 class="my-4">Migrate:latest</h4>
          <p>Perform database mgiration to the latest migration - knex migrate:latest</p>
          <div><b-form-input v-model="testMigrateLatest" placeholder="Write: migrate_latest"></b-form-input></div>
          <div v-if="testMigrateLatest==='migrate_latest'"><b-button variant="danger" v-on:click="latest">Migrate latest</b-button></div>
          <h3 class="my-4">Server response</h3>
          <div><strong>{{message}}</strong></div>
          <div v-show="busy"><i class="fa fa-spinner fa-pulse fa-lg fa-fw"></i></div>
          <h2>Scrape log clean up</h2>
          <div><b-button variant="primary" v-on:click="cleanScrapelog">Clean Scrapelog</b-button></div>
          <h2 class="mt-4">Delete news by id and source</h2>
          <div><b-form-input v-model="newsSource" placeholder="source"></b-form-input></div>
          <div><b-form-input v-model="newsStartId" placeholder="Id equal or greater"></b-form-input></div>
          <div><b-form-input v-model="newsEndId" placeholder="Id equal or smaller"></b-form-input></div>
          <div><b-button variant="primary" v-on:click="deleteNews">Delete items</b-button></div>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import ac from '../libs/accesscontrol'

export default {
  computed: {
    user: {
      get () {
        return this.$store.state.user
      }
    }
  },
  created: function () {
    this.permissions.createMigration = ac.can(this.user.acgroups).createAny('migration').granted
    if (!this.permissions.createMigration) {
      this.$router.push({ name: 'Start' })
    }
  },
  data () {
    return {
      busy: false,
      message: '',
      newsEndId: null,
      newsSource: null,
      newsStartId: null,
      permissions: {},
      testMigrateLatest: ''
    }
  },
  methods: {
    cleanScrapelog: async function () {
      this.busy = true
      try {
        await this.$Amplify.API.get('cosmos', '/scrapelog/cleandb')
        this.message = 'Scrapelog cleaned'
      } catch (e) {
        this.message = e
      }
      this.busy = false
    },
    currentversion: async function () {
      this.busy = true
      try {
        let apiName = 'cosmos'
        let path = '/knex/migrate/currentversion'
        let response = await this.$Amplify.API.get(apiName, path)
        this.message = response
      } catch (e) {
        this.message = e
      }
      this.busy = false
    },
    deleteNews: async function () {
      this.busy = true
      try {
        let apiName = 'cosmos'
        let path = `/news/source/${this.newsSource}/startid/${this.newsStartId}/endid/${this.newsEndId}`
        const response = await this.$Amplify.API.del(apiName, path)
        this.message = response
      } catch (e) {
        this.message = e
      }
      this.busy = false
    },
    latest: async function () {
      this.busy = true
      try {
        let apiName = 'cosmos'
        let path = '/knex/migrate/latest'
        await this.$Amplify.API.get(apiName, path)
        this.testMigrateLatest = ''
        this.message = 'Migration done'
      } catch (e) {
        this.message = e
      }
      this.busy = false
    }
  }
}
</script>

<style>
</style>
